import useJwt from '@/auth/jwt/useJwt'
import { can } from '@/@core/libs/acl/utils'


/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const getUserRole = () => {
    var userData = getUserData();
    var regional = userData.regional ?? null;

    const roleAdmin = checkAkses("admin/home");
    const rolePA = checkAkses("pa/home");
    const roleLokas = checkAkses("lokas/home");
    const roleRemunerasi = checkAkses("remunerasi/home");

    // Logika kondisional tetap sama, karena ini adalah yang paling jelas dan efisien untuk kasus ini.
    if (roleAdmin && rolePA && roleLokas && roleRemunerasi) {
        return "superadmin";
    } else if (roleAdmin && regional === "99") { // Menggunakan === untuk perbandingan ketat
        return "Admin Nasional";
    } else if (roleAdmin && regional !== "99") { // Menggunakan !== untuk perbandingan ketat
        return "Admin Sppd";
    } else if (rolePA && regional === "99") {
        return "Approval Ruta/PA";
    } else if (rolePA && regional !== "99") {
        return "Approval PA Regional";
    } else if (roleLokas) { // Jika roleLokas bernilai truthy (bukan null, undefined, false, 0, '')
        return "Lokas";
    } else if (roleRemunerasi && regional === "99") {
        return "Remunerasi Nasional";
    } else if (roleRemunerasi && regional !== "99") {
        return "Remunerasi Regional";
    } else {
        return "Pegawai";
    }
}

export const checkAkses = (permissionName) => {
    const permissions = localStorage.getItem('all_permission')
    if (typeof permissions != 'undefined') {
        return permissions?.indexOf(permissionName) > -1
    }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
